import React, { Component } from 'react';
import { Icon } from './Icon';
import PropTypes from 'prop-types';

import styles from './rightbar/rightbar.module.scss';

export class Rightbar extends Component {
  componentDidMount() {
    window.addEventListener('resize', this.toggleRightbarOnResize);
    this.toggleRightbarOnResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.toggleRightbarOnResize);
  }

  toggleRightbarOnResize = () => {
    const { toggleRightbar } = this.props;

    if (this.windowWidth === undefined) {
      this.windowWidth = window.innerWidth;

      if (this.windowWidth < 1280) {
        toggleRightbar(false);
      }
    } else {
      if (this.windowWidth < 1280) {
        this.windowWidth = window.innerWidth;
      } else {
        if (window.innerWidth < 1280) {
          this.windowWidth = window.innerWidth;
          this.props.isOpen && toggleRightbar(false);
        }
      }
    }
  };

  render() {
    const {
      className = '',
      arrowClassName = '',
      isOpen = true,
      children,
      isExpanded,
      toggleRightbar,
    } = this.props;

    const rightBarClassNames = [styles.rightbar];
    if (isOpen) {
      rightBarClassNames.push('_is-open');
    } else {
      rightBarClassNames.push('_is-closed');
    }
    if (className) {
      rightBarClassNames.push(className);
    }
    if (isExpanded) {
      rightBarClassNames.push('_is-expanded');
    }

    return (
      <aside className={rightBarClassNames.join(' ')}>
        <div className={styles.wrapper}>
          {children}
          <div
            className={`${styles.arrowWrapper} ${arrowClassName}`}
            onClick={toggleRightbar}
          >
            <div className={styles.arrow}>
              <i className={styles.icon}>
                <Icon name="Left" />
              </i>
              <span className={styles.title}>
                {isOpen ? 'Hide' : 'Show'}
              </span>
            </div>
          </div>
        </div>
      </aside>
    );
  }
}

Rightbar.propTypes = {
  className: PropTypes.string,
  arrowClassName: PropTypes.string,
  isOpen: PropTypes.bool,
  toggleRightbar: PropTypes.func,
  isExpanded: PropTypes.bool,
};
